import { useEffect, useState } from 'react';

const read = (key) => {
  try { return JSON.parse(localStorage.getItem(key)) || null; } catch (e) { return null; }
};

// Remembers a learner's tab + expanded modules/weeks/panels per programme on this device.
export default function useProgrammeUiState(userId, programmeId) {
  const key = `cerebro:programme-ui:${userId || 'anon'}:${programmeId}`;
  const [stored, setStored] = useState(() => read(key));
  // Re-read when the user resolves after auth hydration (key changes from anon to the real user)
  useEffect(() => { setStored(read(key)); }, [key]);
  const save = (next) => {
    setStored(next);
    try { localStorage.setItem(key, JSON.stringify(next)); } catch (e) { /* storage full or blocked */ }
  };
  return [stored, save];
}
